import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  createAdminUser,
  fetchAdminUserById,
  updateAdminUser
} from '../services/admin-users';

function UserForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = Boolean(id);

  const [loading, setLoading] = useState(isEditMode);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    status: 0
  });

  useEffect(() => {
    if (!isEditMode) return;

    const loadUser = async () => {
      setLoading(true);
      setError('');
      try {
        const user = await fetchAdminUserById(id);
        setFormData((prev) => ({
          ...prev,
          email: user.email || '',
          status: user.status || 0
        }));
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load user.');
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [id, isEditMode]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const payload = {
        email: formData.email,
        status: formData.status
      };


      if (formData.password.trim()) {
        payload.password = formData.password;
      }
      console.log(payload,"printhe payload")
      if (isEditMode) {
        await updateAdminUser(id, payload);
      } else {
        if (!payload.password) {
          throw new Error('Password is required for creating a user.');
        }
        await createAdminUser(payload);
      }

      navigate('/users');
    } catch (err) {
      const fallbackMessage = isEditMode ? 'Failed to update user.' : 'Failed to create user.';
      setError(err.response?.data?.message || err.message || fallbackMessage);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>{isEditMode ? 'Update User' : 'Create User'}</h1>
        <p>{isEditMode ? 'Update admin user details' : 'Create a new admin user'}</p>
      </div>

      <div className="section-card">
        <h2>{isEditMode ? 'User Details' : 'New User'}</h2>

        {error && <div className="error-message">{error}</div>}

        <form className="form-container" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              disabled={submitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              Password {isEditMode ? '(Leave blank to keep unchanged)' : '*'}
            </label>
            <input
              id="password"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required={!isEditMode}
              disabled={submitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status *</label>
            <select
              id="status"
              value={formData.status}
              onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              disabled={submitting}
            >
              <option value="1">active</option>
              <option value="0">inactive</option>
            </select>
          </div>

          <div className="btn-group">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? 'Saving...' : (isEditMode ? 'Update User' : 'Create User')}
            </button>
            <Link to="/users" className="btn btn-secondary link-btn">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserForm;
